document.addEventListener('DOMContentLoaded', function() {
  const allDropHeaders = document.querySelectorAll('[id^="custom-drop-header"], .template-search');

  console.log(allDropHeaders);
  
  if (allDropHeaders.length > 0) {
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      
      allDropHeaders.forEach(dropHeader => {
        const headerDiv = dropHeader.querySelector('.drop-header-title-collection-wrapper');
        
        if (headerDiv) {
          const hasImage = dropHeader.querySelector('img') !== null;
          
          // Si el usuario llega al final de la página
          const reachedBottom = scrollTop + windowHeight >= docHeight - 10; // margen de 10px

          if (reachedBottom) {
            headerDiv.style.display = 'none';
          } else {
            headerDiv.style.display = 'flex';
          }

          if (hasImage && !reachedBottom) {
            headerDiv.style.display = '';
            if (scrollTop > 100) {
              headerDiv.classList.add('scrolled');
            } else {
              headerDiv.classList.remove('scrolled');
            }
          }
        }
      });
    });
  }
});
